import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { VictoriousPetition } from '../../../../shared/api';

import { VictoriousPetitionsFromPetitionV2 } from './api.graphql';
import type {
	VictoriousPetitionsFromPetitionV2Query,
	VictoriousPetitionsFromPetitionV2QueryVariables,
} from './api.graphql';

export const MAX_PETITIONS = 4;

type Options = Readonly<{
	petitionSlugOrId?: string;
	locale: string;
	countryCode: string;
}>;

export async function getVictoriousPetitions(
	{ petitionSlugOrId, countryCode, locale }: Options,
	{ gql: { fetch } }: UtilityContext,
): Promise<{ petitions: readonly VictoriousPetition[]; parentPetitionId?: string }> {
	if (petitionSlugOrId) {
		const { data } = await fetch<
			VictoriousPetitionsFromPetitionV2Query,
			VictoriousPetitionsFromPetitionV2QueryVariables
		>({
			query: VictoriousPetitionsFromPetitionV2,
			variables: {
				petitionSlugOrId,
				count: MAX_PETITIONS,
				countryCode,
				locale,
			},
			// to separate query from other batched queries
			batched: false,
			rejectOnError: true,
		});
		if (!data.petition) {
			throw new Error('petition not found');
		}
		return {
			petitions: data.petition.victoriousPetitionsConnection.edges,
			parentPetitionId: data.petition.id,
		};
	}

	// TODO currently no way to retrieve victorious petitions not based on a petition
	return {
		petitions: [],
	};
}
